import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { User } from "../models/user";
import { AuthService } from "./auth.service";
import { map, catchError } from "rxjs/operators";
import { LoggingService } from "./logging.service";

@Injectable({
  providedIn: "root",
})
export class UserService {
  private userSubject$: BehaviorSubject<User>;
  public user$: Observable<User>;

  constructor(private authService: AuthService) {
    LoggingService.log("UserService ctor");
    this.userSubject$ = new BehaviorSubject<User>(null);
    this.user$ = this.userSubject$.asObservable();
  }

  authorized$(): Observable<boolean> {
    return this.authService.loginSilent$().pipe(
      map(user => {
        LoggingService.log(`UserService - authorized ${JSON.stringify(user)}`);

        this.userSubject$.next(user);

        return !!user;
      }),
      catchError(error => {
        LoggingService.log(`UserService authorized failed ${JSON.stringify(error)}`);

        return of(false);
      }),
    );
  }

  login$(): Observable<boolean> {
    return this.authService.loginPopup$().pipe(
      map(user => {
        LoggingService.log(`UserService - login ${JSON.stringify(user)}`);

        return !!user;
      }),
      catchError(error => {
        LoggingService.log(`UserService login failed ${JSON.stringify(error)}`);

        return of(false);
      }),
    );
  }
}
